<template>
  <el-dialog title="物料理论数量" :visible.sync="visible" :close-on-click-modal="false" :close-on-press-escape="false"
             width="80%">
    <SweetTable ref="table" url="/erp/purchase/page"
                :query-form="queryForm" :before-table-binding="beforeTableBinding" api-version="v2" :height="500" :is-page="false">
      <el-table-column
          prop="orderCode"
          label="外销合同编号"
          header-align="center"
          align="center"
          min-width="110"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="batchCode"
          label="批次号"
          header-align="center"
          align="center"
          width="110"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.name"
          label="品名"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.color"
          label="颜色"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.size"
          label="规格"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.attr1"
          label="幅宽"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.attr2"
          label="克重"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column prop="amount" label="单价" width="100" header-align="center" align="center">
      </el-table-column>
      <el-table-column
          prop="count"
          label="计划数"
          header-align="center"
          align="center"
          width="80"
      >
      </el-table-column>
      <el-table-column
          label="已收货"
          header-align="center"
          align="center"
          prop="receiptCount"
          width="80"
      >
      </el-table-column>
      <el-table-column
          label="开票单价"
          header-align="center"
          align="center"
          prop="receiptPrice"
          width="80"
      >
      </el-table-column>
      <el-table-column
          prop="companyName"
          label="供应商"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
          :formatter="$c.companyNameFormatter"
          min-width="160"
      ></el-table-column>
      <el-table-column
          label="收货仓库"
          header-align="center"
          align="center"
          prop="storageName"
          :show-overflow-tooltip="true"
          :formatter="$c.companyNameFormatter"
          min-width="160"
      >
      </el-table-column>
    </SweetTable>
  </el-dialog>
</template>

<script>
import BigNumber from 'bignumber.js'
import SweetTable from '@/mixins/SweetTable'

/**
 * 根据特定查询条件显示采购订单列表的弹窗
 */
export default {
  name: 'purchase-table-dialog',
  mixins: [SweetTable],
  components: {},
  data () {
    return {
      visible: false,
      queryForm: {
        materialId: '',
        orderId: ''
      },
    }
  },
  methods: {
    init (queryForm) {
      this.queryForm = {
        ...queryForm
      }
      this.visible = true
      this.$nextTick(() => {
        this.reload()
      })
    },
    beforeTableBinding (dataList) {
      dataList.forEach(item => {

      })
    }
  },
}
</script>

<style lang="scss" scoped>
.count-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 10px;
}
</style>
